import useWindowSize from "../utils/hooks/useWindowSize";
import { useState } from "react";
import { GalleryLightBox } from "./index";
import { PageContainer } from "./PagesComponents";
import {
  ImagesWrapperSinglePage,
  PhotoGalleryPage,
} from "styles/jss/PhotoGallery.styles";
import { Container } from "@mui/material";
import Loader from "./Loader";
import { GalleryCard } from "./PagesComponents/PhotoGallery";
import { MainPage } from "../styles/jss/Layout.styles";

export default function PhotoGallery(props) {
  const { name, page_info, images, isError, isLoading } = props;

  const { width } = useWindowSize();

  const size = {
    width: width > 900 ? 280 : 249,
    height: width > 900 ? 400 : 349,
  };

  const [index, setIndex] = useState(-1);

  return (
    <PageContainer
      seo_info={page_info?.seo_info}
      title={name}
      banner={page_info?.banner}
    >
      <MainPage>
        <PhotoGalleryPage>
          <Container>
            {isLoading ? (
              <Loader />
            ) : isError ? (
              ""
            ) : (
              <ImagesWrapperSinglePage width={size.width} height={size.height}>
                {images.data.map((img, index) => {
                  const { id, attributes } = img;
                  return (
                    <GalleryCard
                      key={id}
                      {...attributes}
                      onClick={() => setIndex(index)}
                    />
                  );
                })}
              </ImagesWrapperSinglePage>
            )}
          </Container>
        </PhotoGalleryPage>
        <GalleryLightBox
          images={images?.data || []}
          setIndex={setIndex}
          index={index}
        />
      </MainPage>
    </PageContainer>
  );
}
